import Pagination from "../../../components/Pagination.vue";
import UserService from "../../../services/UserService";
import { alertResponseError, alertResponseSuccess } from "../../../helpers/general";
import * as Swal from "sweetalert2";
import { ROLE } from "../../../const/role";
    export default {
        components: {
            appPagination: Pagination
        },
        data() {
            return {
                pagination : {
                    currentPage: 1,
                    pageCount: 1,
                },
                arrUsers: [],
          }
        },
        created() {
            document.title = this.$t(`${this.$route.meta.title}.title_page`);
            this.reloadData();
        },
        computed: {
            isAdmin() {
                const user = JSON.parse(localStorage.getItem('user'));
                return user && user.admin === ROLE.ROLE_USER_ADMIN;
            },
            currentUserId() {
                const user = JSON.parse(localStorage.getItem('user'));
                return user.id;
            }
        },
        methods: {
            reloadData() {
                this.getAllUser();
            },
            getAllUser() {
                UserService.getAllUsers(this.pagination.currentPage).then((response) => {
                    if (response.data.success) {
                        this.pagination.pageCount = response.data.data.count;
                        this.arrUsers = response.data.data.results;
                    }
                }).catch((error) => {
                    alertResponseError(error);
                })
            },
            deleteUser(userId) {
                Swal.fire({
                    text: this.$t('user_list.confirm_delete_user'),
                    icon: 'info',
                    showCloseButton: true,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: this.$t('common.yes'),
                    cancelButtonText: this.$t('common.no'),
                    reverseButtons: true,
                }).then((result) => {
                    if (result.value) {
                        UserService.deleteUser(userId).then((response) => {
                            if (response.data.success) {
                                alertResponseSuccess(this.$t('common_message.delete_success'));
                                this.reloadData();
                            }
                        }).catch((error) => {
                            alertResponseError(error);
                        });
                    }
                });
        }
    }
  };